import { render, staticRenderFns } from "./TelInfo.vue?vue&type=template&id=0c581f2b&scoped=true"
import script from "./TelInfo.vue?vue&type=script&lang=js"
export * from "./TelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c581f2b",
  null
  
)

export default component.exports